import React, { createContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLogin, setIsLogin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [LoginUser, SetLogedinUser] = useState(null);

  const url = "https://swaggerback.mondfx.com/";

  const logout = () => {
    setIsLogin(false);
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    SetLogedinUser(null);
  };

  const login = () => setIsLogin(true);

  const setLoginUser = (name) => {
    localStorage.setItem("username", name);
  };

  // ✅ تابع جدا برای گرفتن اطلاعات کاربر لاگین‌شده
  const fetchLoginUser = async () => {
    const token = localStorage.getItem("token");
    if (!token) return null;

    try {
      const response = await fetch(`${url}api/v1/auth/me`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        SetLogedinUser(data);
        if (data.email) {
          localStorage.setItem("username", data.email);
          setIsLogin(true);
        }
        return data;
      } else {
        logout();
        return null;
      }
    } catch (error) {
      console.error("Token validation error:", error);
      logout();
      return null;
    }
  };

  // ⛳ بار اول: بررسی توکن و گرفتن یوزر
  useEffect(() => {
    const init = async () => {
      await fetchLoginUser();
      setLoading(false);
    };
    init();
  }, []);

  if (loading) return null;

  return (
    <AuthContext.Provider
      value={{
        isLogin,
        login,
        logout,
        toggleLogin: () => setIsLogin((prev) => !prev),
        setLoginUser,
        LoginUser,
        url,
        fetchLoginUser, // ✅ اینو به بیرون می‌دیم
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
